import React from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
    size?: 'sm' | 'md' | 'lg';
    fullWidth?: boolean;
}

export const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    className,
    ...props
}: ButtonProps) => {
    const baseStyles = "inline-flex items-center justify-center font-bold tracking-wide uppercase transition-all duration-300 rounded-hesn focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

    const variants = {
        primary: "bg-secondary text-white hover:bg-primary-dark focus:ring-primary-light",
        secondary: "bg-primary text-white hover:bg-primary-light focus:ring-secondary",
        outline: "border-2 border-secondary text-secondary hover:bg-secondary hover:text-white",
        ghost: "text-secondary hover:bg-slate-100",
    };

    const sizes = {
        sm: "px-4 py-2 text-xs",
        md: "px-6 py-3 text-sm",
        lg: "px-8 py-4 text-base",
    };

    return (
        <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className={twMerge(
                clsx(
                    baseStyles,
                    variants[variant],
                    sizes[size],
                    fullWidth && "w-full"
                ),
                className
            )}
            {...props}
        >
            {children}
        </motion.button>
    );
};
